module.exports = __webpack_public_path__ + "static/media/iconSetting.30cfa0d1.svg";